<script setup lang="ts">
import { getFormattedCurrencyAmount } from "mws-utils/lib";

type Props = {
  iso: string;
  value?: number;
  showDecimals?: boolean;
  isInCents?: boolean;
};

const {
  iso,
  value = 0,
  showDecimals,
  isInCents = false,
} = defineProps<Props>();

const { locale } = useI18n();

const amount = computed(() => {
  const priceInCents = !isInCents ? value * 100 : value;

  return getFormattedCurrencyAmount(
    locale.value,
    iso,
    priceInCents,
    showDecimals,
  );
});
</script>

<template>
  <span
    class="currency"
    data-test="currency"
  >
    {{ amount }}
  </span>
</template>
